import { render, staticRenderFns } from "./successTips.vue?vue&type=template&id=4073b6d4&scoped=true&"
import script from "./successTips.vue?vue&type=script&lang=js&"
export * from "./successTips.vue?vue&type=script&lang=js&"
import style0 from "./successTips.vue?vue&type=style&index=0&id=4073b6d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4073b6d4",
  null
  
)

export default component.exports